import {useQuery} from "@apollo/client";
import {GarageBookingQuery, GET_GARAGE_BOOKING} from "@App/graphql/queries";
import {useSelector} from "react-redux";
import {State} from "@App/state";
import {useDates} from "@App/hooks/useDates";
import {useCalculation} from "@App/hooks/useCalculation";

/**
 * Hook that alerts clicks outside the passed ref
 */
export const useGarageCalculation = () => {
    const {formatDate, toIsoString} = useDates()

    const {
        organization,
        service,
        garage,
        filterBrand,
        brand,
        generation,
        motorization,
        body,
        gearbox,
        mileage,
        initialRegistrationDate,
        subRepairs,
        equipments,
        premiumServices
    } = useCalculation()

    const place = useSelector((state: State) => state.orders.place)
    const dates = useSelector((state: State) => state.filters.dates)
    const driverID = useSelector((state: State) => state.auth?.driverData?.uuid)

    const {loading, data, error} = useQuery<GarageBookingQuery>(GET_GARAGE_BOOKING, {
        variables: {
            id: garage.id,
            organization: organization.id,
            lat: place.lat,
            lon: place.lon,
            appointmentsFrom: dates && dates.from ? toIsoString(dates.from) : null,
            appointmentsTo: dates && dates.to ? toIsoString(dates.to) : null,
            brand: brand
                ? brand.id
                : filterBrand
                    ? filterBrand.id
                    : null,
            generation: generation ? generation.id : null,
            motorization: motorization ? motorization.id : null,
            body: body ? body.id : null,
            gearbox: gearbox ? gearbox.id : null,
            mileage: mileage,
            registrationDate: initialRegistrationDate ? formatDate(initialRegistrationDate, 'yyyy-MM-dd') : null,
            services: [service.id],
            premiumServices: premiumServices && premiumServices.length > 0 ? premiumServices.map((p) => p.id) : null,
            equipments: equipments.map(equipment => equipment.name),
            subRepairs: subRepairs,
            driverID: driverID,
        },
        skip: !organization || !place || !place.lat
    })

    return {
        loading,
        garageCalculation: data && data.organization.garages.data.length > 0
            ? data.organization.garages.data[0].calculation
            : null,
        error
    }
}
